import axios from 'axios'

export default {
    getCategories() {
        return axios.get('/api/categories')
    },

    createRoom(name, level, category, game_time) {
        return axios.post('/games/simple-group-game/rooms', {
            name: name,
            level: level,
            category: category,
            game_time: game_time,
        })
    },

    findGame(code) {
        return axios.get('/games/simple-group-game/room/find', {
            params: {
                code: code
            }
        })
    }
}
